import {scrollToElement} from '@/utils/scrollToElement';

export const goToHomeSection = (hash: string) => {
  // 300 is how long it takes for the header to hide when scrolling
  setTimeout(() => scrollToElement(hash.replace('#', '')), 300);
};
